import * as React from 'react';
import { navConfig } from '@app/src/utils/categories';
import {
  Wrapper,
  Subtitle,
  Legacy,
  Container,
  Social,
  Network,
  TermsAndConditions,
  AssesorsWrapper,
  IconWrapper,
  SecurityWrapper,
  CentralHelp,
  CentralHelpSubtitle
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { Copyright } from '@app/src/common/footer';
import * as BookClaimer from '@app/src/assets/img/book-claimer.jpg';
import { isClientEnv } from '@app/src/utils/validations';
import { TERM_AND_CONDITIONS } from '@app/src/config/footer';

interface Props {
  isDisplay?: boolean;
  className?: string;
}

const isClient = isClientEnv();
const BOOK_RECLAMATIONS = 'http://ecomedia.pe/libro/inicio/clasificados/';

export const Footer: React.FC<Props> = ({ isDisplay, className }) => {

  const handleClick = (e) => {
    let element = e.target;
    if (element.href) {
      pushDatalayer(element.href, element.textContent);
    }
  }

  const pushDatalayer = (href:string, text:string) => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Footer',
        'eventAction': href,
        'eventLabel': text,
        'eventValue': 1
      })
    }
  }

return(
  <Wrapper isDisplay={isDisplay} className={className} onClick={e => handleClick(e)}>
    <Container>
      <div>
        <SecurityWrapper />
        <AssesorsWrapper />
      </div>
      <CentralHelp>
        <TermsAndConditions>
          <Icon data-name="icon-dialog" fill="#fff" width="40" height="40" />
          <CentralHelpSubtitle>Central de ayuda</CentralHelpSubtitle>
          {
            TERM_AND_CONDITIONS &&
            TERM_AND_CONDITIONS.map((term, key) => (
              <li key={key}><a target="_blank" href={term.link}>{term.text}</a></li>
            ))
          }
        </TermsAndConditions>
      </CentralHelp>
      <Social>
        <Subtitle>Visita nuestro facebook</Subtitle>
        <Network>
          {
            navConfig.map((item, index) =>
              <a href={item.linkFb} target="_blank" key={index}>
                <IconWrapper>
                  <Icon data-name={item.icon} fill="#fff" width="24" height="20" />
                </IconWrapper>
              </a>
            )
          }
        </Network>
      </Social>
      <Legacy>
        <a target="_blank" href={BOOK_RECLAMATIONS}>
          <img src={BookClaimer} />
        </a>
        <Copyright />
      </Legacy>
    </Container>
  </Wrapper>
)};
